import img1 from './../../../assets/images/our-people.jpg';
import img2 from './../../../assets/images/cadet-paths.jpg';
import CadetshipLogoSlider from '../CadetshipLogoSlider';

function Cadetship() {
    return (
        <>
            <div className="service-title text-green-38B652 font-700 mb-3">Cadetship​ Introduction</div>
            {/* <div className="service-box mb-5 mb-sm-4">ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,  quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo  consequat. Duis aute irure dolor.</div> */}

            <div className="row g-3 g-sm-4 g-md-5">
                <div className="col-12">
                    <p className="font-17 text-primary-color mb-3">The South African Maritime Safety Authority (SAMSA) as part of its mandate by the Government developed a maritime strategy to grow and develop the country’s maritime economy. </p>

                    <p className="font-17 text-primary-color mb-3">​One of the key challenges arising out of this strategy was the current shortage of both sea and shore based human resources required to support the industry. </p>

                    <p className="font-17 text-primary-color mb-3">This has been exacerbated by the reduction in South African based shipping companies, an issue which they also intend to address by the introduction of a new tonnage tax regime and related industry incentives.</p>

                    <p className="font-17 text-primary-color mb-3">It is recognised that the shortage of training berths for cadets is the key obstacle to addressing the above mentioned shortage.</p>

                    <p className="font-17 text-primary-color mb-3">In response to this, government, through SAMSA, has therefore decided to fully sponsor cadet training programmes on the basis that third party shipping companies will make training berths available, at no real cost to them, </p>

                    <p className="font-17 text-primary-color mb-3">to train these cadets on their vessels and once qualified to be free to employ these cadets in their own fleets.</p>

                    <p className="font-17 text-primary-color mb-3">This will serve to address the high unemployment situation in the country and increase human capital in the industry.</p>



                </div>

                <div className="col-12">
                    <div className="row g-5">
                        <div className="col-md-6 col-sm-6">
                            <div class="card h-100">
                                <img src={img1} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title font-600">Our People</h5>
                                    <p class="card-text">​Cadetship Partner
                                        {/* <a className='text-decoration-none text-green-38B652' href="#">​Cadetship Partner​</a> */}
                                        </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div class="card h-100">
                                <img src={img2} class="card-img-top" alt="..." />
                                <div class="card-body">
                                    <h5 class="card-title font-600">​Cadet Paths</h5>
                                    <p class="card-text">Cadetship Partner
                                        {/* <a className='text-decoration-none text-green-38B652' href="#">Cadetship Partner </a> */}
                                    </p>
                                    <p class="card-text">Engineering officer
                                        {/* <a className='text-decoration-none text-green-38B652' href="#">Engineering officer </a> */}
                                    </p>
                                    <p class="card-text">Training Programme 
                                        {/* <a className='text-decoration-none text-green-38B652' href="#">Training Programme  </a> */}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <p className="font-17 text-primary-color mb-3"><b>National Cadet Training Programme for March 2011</b></p>

                    <p className="font-17 text-primary-color mb-3">The South African Maritime Training Academy (SAMTRA) seeks training berths from reputable shipping companies/managers for the purpose of training South African cadets as part of an initiative funded by the SA government to grow the country’s maritime capabilities and address the country’s high unemployment.</p>

                    <p className="font-17 text-primary-color mb-3">What's in it for ship owners / managers?​</p>

                    <p className="font-17 text-primary-color mb-3">Shipping companies/managers who participate in the project will not be expected to bear any costs of training the cadets other than the cost of victuals and onboard incidentals. </p>

                    <p className="font-17 text-primary-color mb-3">The benefit to participating companies is that they train cadets to their standards and subsequently employ the cadets once qualified, without real cost to them.</p>


                </div>

                <div className="col-12">
                    <p className="font-17 text-primary-color mb-3"><b>Why South Africans?</b></p>

                    <p className="font-17 text-primary-color mb-3">Added benefits to European ship-owners of employing SA Cadets and officers are:</p>

                    <ul className='list-order'>
                        <li>South Africa is on the IMO White list and Qualifications are fully STCW compliant</li>
                        <li>South Africa Certificates of Competency are recognized by UK, Australian, Danish, Belgium & other respectable maritime authorities.</li>
                        <li>English language is generally spoken – higher education and nautical colleges conduct education in English</li>
                        <li>Work ethic – South Africans are generally regarded as having a good work ethic with a culture of “making a plan” when required and a sense of responsibility. </li>
                        <li>Companies that currently employ SA officers include – Maersk, Safmarine, Smit, Swire, BP, Stolt, Posh SEMCO, Stena, Tidewater, Sanko, and with respect to hotel staff - various cruise ship companies</li>
                        <li>A convenient time zone alignment with Europe – GMT +2 that enables easier communications.</li>
                    </ul>
                </div>

                <div className="col-12">
                    <p className="font-17 text-primary-color mb-3"><b>What does the project entail?</b></p>

                    <ul className='list-order'>
                        <li>SAMTRA – a non-profit organization based in Cape Town, South Africa - has been contracted by the South African government/SAMSA to manage project of training cadets from recruitment though to preparation for final exams as Officer of the Watch.</li>
                        <li>SAMTRA has been in operation for eight years and has successfully managed cadet training programs for SafMarine, The National Port Authority & STENA.</li>
                        <li>Training costs are being funded by the SA government through their agency SAMSA. This includes all costs normally associated with training a cadet (including cadet allowances, working gear, all travel, documentation, all required courses etc.). </li>
                        <li>However, onboard victuals and other incidentals are to be borne by the participating companies.</li>
                        <li>Participating shipping companies are expected to provide training berths, to mentor and monitor onboard training using either the participating company’s own training record book </li>
                        <li>(which will be submitted to SAMSA for accreditation) or the SAMSA training record book which is based on the ISF record book.</li>
                        <li>The first intake of cadets (who have completed their first year of theory studies) will commence with their pre-sea safety courses and induction in April.</li>
                        <li>They will then be appointed to the above mentioned companies with further intakes joining the programs over the coming months.</li>
                    </ul>
                </div>

                <div className="col-12">
                    <p className="font-17 text-primary-color">Who to contact for more information: Contact the SAMTRA training Manager-Pieter Coetzee on the following email address : <a href="mailto:training@samtra.co.za"> training@samtra.co.za</a>​</p>
                </div>

                <CadetshipLogoSlider />


            </div>
        </>
    )
}

export default Cadetship;